import { ThunkMiddleware } from 'redux-thunk';
import { AnyAction } from 'redux';

import { GlobalState } from 'ha/types/store';
import { AppServices } from 'ha/services/getAppServices';
import { AuthLogicTypes } from 'ha/modules/AuthLogic/constants';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { Actions as NavBarActions } from 'ha/modules/NavBar/actions';
import { getPendingListings } from '../selectors';
import addFavoriteListing, {
  ActionTypes as addFavoriteListingActionsTypes,
} from '../actions/addFavoriteListing';

const favoriteListingMiddleware: ThunkMiddleware<
  GlobalState,
  AnyAction,
  AppServices
> = ({ dispatch, getState }) => next => action => {
  next(action);

  if (action.type === addFavoriteListingActionsTypes.ADD_TO_PENDING_LIST) {
    const state = getState();
    const isAuthenticated = getIsAuthenticated(state);

    if (!isAuthenticated) {
      dispatch(NavBarActions.showModal('register'));
    } else {
      const listingId = action.payload;
      dispatch(addFavoriteListing(listingId));
    }
  }

  if (action.type === AuthLogicTypes.login) {
    const state = getState();
    const pendingListings = getPendingListings(state);

    pendingListings.forEach(id => dispatch(addFavoriteListing(id)));
  }
};

export default favoriteListingMiddleware;
